import "./style.css";

import Button from "../Button";

type ICustomLogoProps = {
  customLogotypeUrl?: string;
}

const CustomLogo: React.VFC<ICustomLogoProps> = ({ customLogotypeUrl }) => {
  return (
    <Button>
      <img className='custom-player-logotype' src={customLogotypeUrl} alt='Logotipo customizado da marca' />
    </Button>
  );
};

export default CustomLogo;
